import { useState, useEffect } from 'react'
import { APP_CONSTANTS } from '../../../config/constants'

export function useTimer(setRefreshData: any, refreshDataTime: any) {
  const [timer, setTimer] = useState(refreshDataTime ?? 20)
  const [counter, setCounter] = useState<number>(1000)
  const [refresh, setRefresh] = useState<boolean>(true)
  const [intervalId, setIntervalId] = useState(0)

  useEffect(() => {
    const localStorageCounter = localStorage.getItem(
      APP_CONSTANTS.LS_AUTOREFRESH
    )
    if (localStorageCounter) {
      const counterValue = JSON.parse(localStorageCounter)
      counterValue && setCounter(counterValue.counter)
      counterValue && setRefresh(true)
    }
  }, [])
  useEffect(() => {
    let x = timer
    let refreshData = 0
    if (refresh && !intervalId && counter > 0) {
      const tempId: any = setInterval(() => {
        if (x > 0) setTimer(x--)
        else {
          x = refreshDataTime
          setTimer(refreshDataTime)
          refreshData = (refreshData + 1) % 2
          setRefreshData(refreshData)
        }
      }, counter)
      localStorage.setItem(
        APP_CONSTANTS.LS_AUTOREFRESH,
        `{"counter":${counter}}`
      )
      setIntervalId(tempId)
    } else if (refresh && intervalId) {
      clearInterval(intervalId)
      const tempId: any = setInterval(() => {
        if (x > 0) setTimer(x--)
        else {
          x = refreshDataTime
          setTimer(refreshDataTime)
          refreshData = (refreshData + 1) % 2
          setRefreshData(refreshData)
        }
      }, counter)
      localStorage.setItem(
        APP_CONSTANTS.LS_AUTOREFRESH,
        `{"counter":${counter}}`
      )
      setIntervalId(tempId)
    } else if (!refresh) {
      clearInterval(intervalId)
      localStorage.removeItem(APP_CONSTANTS.LS_AUTOREFRESH)
      setIntervalId(0)
    }
  }, [])
  return [timer, setTimer]
}
